export default __webpack_public_path__ + "static/media/home.382ffe07.svg";